// NEWSLETTER SIGNUP - Mailchimp JSONP submission handler
// Handles every .fg-newsletter-form on the page (footer, in-article, recipe,
// recipe index, collection). Also powers a one-time 60%-scroll-depth
// slide-in reveal for forms marked with [data-newsletter-scroll-trigger].
(function () {
  'use strict';

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function isValidEmail(value) {
    return EMAIL_RE.test(value);
  }

  function showMessage(form, type, text) {
    var msgEl = form.querySelector('.fg-newsletter-msg');
    if (!msgEl) {
      return;
    }
    msgEl.textContent = text;
    msgEl.classList.remove('fg-newsletter-msg--success', 'fg-newsletter-msg--error');
    msgEl.classList.add(type === 'success' ? 'fg-newsletter-msg--success' : 'fg-newsletter-msg--error');
    msgEl.setAttribute('role', 'alert');
    msgEl.hidden = false;
  }

  function setSubmitting(form, isSubmitting) {
    var button = form.querySelector('button[type="submit"]');
    if (button) {
      button.disabled = isSubmitting;
    }
  }

  function submitToMailchimp(form) {
    var u = form.getAttribute('data-mailchimp-u');
    var dc = form.getAttribute('data-mailchimp-dc');
    var listId = form.getAttribute('data-mailchimp-list');

    if (!u || !dc || !listId) {
      showMessage(form, 'error', 'Newsletter is not configured. Please try again later.');
      return;
    }

    var emailInput = form.querySelector('input[name="EMAIL"]');
    var sourceInput = form.querySelector('input[name="SOURCE"]');
    var honeypot = form.querySelector('input[name^="b_"]');
    var conditionCheckboxes = form.querySelectorAll('.fg-newsletter-conditions input[type="checkbox"]:checked');

    if (honeypot && honeypot.value) {
      return;
    }

    var email = emailInput ? emailInput.value.trim() : '';
    var source = sourceInput ? sourceInput.value : '';

    if (!isValidEmail(email)) {
      showMessage(form, 'error', 'Please enter a valid email address.');
      if (emailInput) {
        emailInput.focus();
      }
      return;
    }

    var callbackName = 'fgNewsletterCb' + Date.now() + Math.floor(Math.random() * 100000);
    var script = document.createElement('script');
    var timeoutId;

    function cleanup() {
      clearTimeout(timeoutId);
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
      delete window[callbackName];
      setSubmitting(form, false);
    }

    window[callbackName] = function (response) {
      cleanup();
      if (response && response.result === 'success') {
        showMessage(form, 'success', response.msg || 'Thank you for subscribing!');
        form.reset();
        if (window.dataLayer) {
          window.dataLayer.push({ event: 'newsletter_signup', source: source });
        }
      } else {
        var msg = (response && response.msg) || 'Something went wrong. Please try again.';
        msg = msg.replace(/^\d+\s*-\s*/, '');
        if (/already (a list member|subscribed)/i.test(msg)) {
          msg = "Looks like you're already on the list \u2014 thanks for being here!";
        }
        showMessage(form, 'error', msg);
      }
    };

    script.onerror = function () {
      cleanup();
      showMessage(form, 'error', 'Something went wrong. Please try again.');
    };

    setSubmitting(form, true);

    var paramParts = [
      'u=' + encodeURIComponent(u),
      'id=' + encodeURIComponent(listId),
      'EMAIL=' + encodeURIComponent(email),
      'SOURCE=' + encodeURIComponent(source)
    ];
    for (var ci = 0; ci < conditionCheckboxes.length; ci++) {
      paramParts.push(encodeURIComponent(conditionCheckboxes[ci].name) + '=' + encodeURIComponent(conditionCheckboxes[ci].value));
    }
    paramParts.push('c=' + callbackName);
    var params = paramParts.join('&');

    script.src = 'https://foodguides.' + dc + '.list-manage.com/subscribe/post-json?' + params;
    script.async = true;

    timeoutId = setTimeout(function () {
      cleanup();
      showMessage(form, 'error', 'The request timed out. Please try again.');
    }, 10000);

    document.body.appendChild(script);
  }

  function bindForm(form) {
    if (form.dataset.fgNewsletterBound === 'true') {
      return;
    }
    form.dataset.fgNewsletterBound = 'true';
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      submitToMailchimp(form);
    });
  }

  function bindAllForms(root) {
    var scope = root || document;
    var forms = scope.querySelectorAll('.fg-newsletter-form');
    for (var i = 0; i < forms.length; i++) {
      bindForm(forms[i]);
    }
  }

  function scrollDepthPercent() {
    var scrollTop = window.scrollY || document.documentElement.scrollTop;
    var docHeight = document.documentElement.scrollHeight - window.innerHeight;
    if (docHeight <= 0) {
      return 0;
    }
    return scrollTop / docHeight;
  }

  function revealSlideIn(triggerForm, source) {
    var wrapper = document.createElement('div');
    wrapper.className = 'fg-newsletter-slidein-wrapper';

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'fg-newsletter-slidein-close';
    closeBtn.setAttribute('aria-label', 'Dismiss newsletter signup');
    closeBtn.innerHTML = '&times;';
    closeBtn.addEventListener('click', function () {
      wrapper.classList.remove('is-visible');
      window.setTimeout(function () {
        if (wrapper.parentNode) {
          wrapper.parentNode.removeChild(wrapper);
        }
      }, 350);
    });

    var clone = triggerForm.closest('.fg-newsletter').cloneNode(true);
    clone.removeAttribute('id');
    var clonedForm = clone.querySelector('.fg-newsletter-form');
    if (clonedForm) {
      clonedForm.removeAttribute('data-newsletter-scroll-trigger');
      delete clonedForm.dataset.fgNewsletterBound;
    }

    wrapper.appendChild(closeBtn);
    wrapper.appendChild(clone);
    document.body.appendChild(wrapper);
    bindAllForms(wrapper);

    window.requestAnimationFrame(function () {
      wrapper.classList.add('is-visible');
    });
  }

  function initScrollReveal() {
    var triggerForm = document.querySelector('[data-newsletter-scroll-trigger]');
    if (!triggerForm) {
      return;
    }

    var source = triggerForm.getAttribute('data-source') || 'article-inline';
    var storageKey = 'fgNewsletterRevealed:' + source;

    try {
      if (window.sessionStorage.getItem(storageKey)) {
        return;
      }
    } catch (e) {
      // sessionStorage unavailable, fall back to showing once per page load only.
    }

    var revealed = false;

    function onScroll() {
      if (revealed) {
        return;
      }
      if (scrollDepthPercent() >= 0.6) {
        revealed = true;
        window.removeEventListener('scroll', onScroll);
        revealSlideIn(triggerForm, source);
        try {
          window.sessionStorage.setItem(storageKey, '1');
        } catch (e) {
          // ignore
        }
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function init() {
    bindAllForms(document);
    initScrollReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
